import { recordTestInstance } from '../axios';

const getInspectionCodesByCustomer = (customerId: string, dispCode?: string) => recordTestInstance.post(`/inspection-code/${customerId}`, { customerId, dispCode });

export default getInspectionCodesByCustomer;